module.exports = __webpack_public_path__ + "img/play.2533c1ef.png";